<template>
    <div :class="['sidebar', { 'is-visible': isVisible }]">
        <div v-if="isAuthenticated">
            <ul v-if="menuItems.length">
                <li v-for="item in menuItems" :key="item.id" @click="navigateTo(item.url)">
                    <div class="icon"><img :src="'assets/icons/' + item.name + '.svg'" alt="Icon" /></div>
                    <a>{{ item.name }}</a>
                </li>
            </ul>
            <p v-else>Loading menu...</p>
        </div>
    </div>
</template>

<script>
import UrlLoaderService from '@/services/urlLoader';

export default {
    data() {
        return {
            menuItems: [], // Menu items fetched from backend
            isLoaded: false
        };
    },
    watch: {
        isAuthenticated(newVal) {
            if (newVal && !this.isLoaded) {
                this.fetchMenuItems();
            }
        }
    },
    methods: {
        toggleVisibility() {
            this.$emit('open-menu');
        },
        async fetchMenuItems() {
            try {
                const response = await UrlLoaderService.get('/menu');
                this.menuItems = response.data.menus;
                this.isLoaded = true;
            } catch (error) {
                this.errorMessage = 'There was an error fetching the data.';
                console.error(error);
            }
        },
        navigateTo(routerPath) {
            this.$router.push(routerPath);
            this.toggleVisibility();
        }
    },
    computed: {
        isAuthenticated() {
            return this.$store.state.isAuthenticated;
        },
    },
    props: {
        isVisible: {
            type: Boolean,
            default: false
        }
    },
};
</script>

<style scoped>
.icon {
    width: 20px;
    height: 20px;
    margin-right: .5rem;
}

.sidebar {
    position: absolute;
    top: var(--header-height);
    padding-left: 8px;
    padding-right: 8px;
    width: 250px;
    color: white;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    border-bottom-right-radius: 4px;
    background-color: var(--secondary);
    height: 90%;
}

.sidebar.is-visible {
    transform: translateX(0);
    /* Slide in */
}

.sidebar.retracted {
    width: 80px;
}

button {
    margin: 10px;
    padding: 5px 10px;
    background-color: #444;
    color: white;
    border: none;
    cursor: pointer;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    padding-left: 8px;
    height: 36px;
    margin-top: 8px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;

    &:hover {
        background-color: var(--color-600);
        border-radius: 4px;
        cursor: pointer;
    }
}

a {
    color: white;
    text-decoration: none;
    font-size: 16px;
    font-weight: 600;

    &:hover {
        text-decoration: none;
    }
}
</style>